export enum MenuType {
  Manager = 1,
  Grower = 2,
  OrganizationSettings = 3,
  PlatformAdministration = 4,
  Generic = 5
}
